import Page from '../models/page';

function initSchoolSelection() {
  if (Page.controller !== 'registrations') return;

  const $school = $('#user_school');

  $school.typeahead({
    name: 'School',
    local: $school.data('source'),
  });
}

export default initSchoolSelection;
